import styled from 'styled-components'

export const Field = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

// Note: reserves the error row (1.6rem + its 2px margin) so an appearing error doesn't shift the popup
export const ErrorSlot = styled.div({
  minHeight: '1.8rem',
})

export const Options = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['8'],
}))

export const IconOption = styled.button<{ $color: string; $selected: boolean }>(
  ({ theme, $color, $selected }) => ({
    '&:hover': {
      borderColor: $color,
    },
    alignItems: 'center',
    background: $selected ? $color : theme.colors.white,
    border: `${theme.border.size['1']} solid ${$selected ? $color : theme.colors.gray700}`,
    borderRadius: theme.border.radius['8'],
    color: $selected ? theme.colors.white : theme.colors.black700,
    cursor: 'pointer',
    display: 'flex',
    height: '5.2rem',
    justifyContent: 'center',
    padding: 0,

    svg: {
      maxHeight: '3.2rem',
      maxWidth: '3.2rem',
    },
    width: '5.2rem',
  }),
)

export const ColorOption = styled.button<{ $color: string; $selected: boolean }>(
  ({ theme, $color, $selected }) => ({
    background: $color,
    border: `${theme.border.size['2']} solid ${$selected ? theme.colors.black800 : 'transparent'}`,
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${theme.border.size['2']} ${theme.colors.white}`,
    cursor: 'pointer',
    height: '3.2rem',
    padding: 0,
    width: '3.2rem',
  }),
)
